import { resolveMemberColor } from "./memberColors";

/** Active members shown on the split wheel and payout calculations. */
export function wheelMembers(members = []) {
    return members
        .filter((m) => (m.status ?? "active") === "active")
        .map((m) => ({ ...m, color: resolveMemberColor(m.color) }));
}

/** Members shown in recipient lists (includes pending invites). */
export function rosterMembers(members = []) {
    return members
        .filter((m) => {
            const status = m.status ?? "active";
            return status === "active" || status === "pending_invite";
        })
        .map((m) => ({ ...m, color: resolveMemberColor(m.color) }));
}

export function isPrimaryPoolOwner(member, pool) {
    return Boolean(member?.user_id && member.user_id === pool?.owner_user_id);
}

export function isPoolCoOwner(member, pool) {
    if (isPrimaryPoolOwner(member, pool)) return false;
    if (member?.is_owner) return true;
    const ownerIds = pool?.owner_user_ids || [];
    return Boolean(member?.user_id && ownerIds.includes(member.user_id));
}

/**
 * Recipient list badge — never uses member.verified for display (that flag means bank on file in the API).
 */
export function recipientBadgeStatus(member) {
    const status = member?.status ?? "active";
    const hasBank = !!member?.bank?.account_last4;
    if (status === "pending_invite") return "awaiting_invite";
    if (hasBank) return "ready";
    if (member?.user_id) return "payout_setup";
    return "needs_bank";
}

/** Whether the current user can remove this pool member from the UI/API. */
export function canRemovePoolMember(member, pool, actorUserId) {
    if (isPrimaryPoolOwner(member, pool)) return false;
    if (isPoolCoOwner(member, pool)) return pool?.owner_user_id === actorUserId;
    return true;
}
